var _circle, _circle2, _circle3, _circle4, _circle5, _circle6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNonCluster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 3.45703,
    cy: 3.76465,
    r: 2.5,
    fill: "#2AB75A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.08765,
    cy: 5.5,
    r: 2.5,
    fill: "#C7432B"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 3.76465,
    r: 2.5,
    fill: "#2AB75A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 8.76465,
    r: 2.5,
    fill: "#C7432B"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.58765,
    cy: 11.2646,
    r: 2.5,
    fill: "#2AB75A"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 8.76465,
    r: 2.5,
    fill: "#C7432B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNonCluster);
export default __webpack_public_path__ + "static/media/NonCluster.a44a75ed00865ae6b84d98f0fe99d282.svg";
export { ForwardRef as ReactComponent };